export const QUERY_CONFIG = {
  DEFAULT_STALE_TIME: 5 * 60 * 1000,
  DEFAULT_REFETCH_INTERVAL: 5 * 60 * 1000 + 1,
  DEFAULT_MIGRATION_ENTITY_CACHE_TIME: 2 * 60 * 1000 + 1,
  DEFAULT_MIGRATION_ENTITY_REFETCH_INTERVAL: 2 * 60 * 1000 + 1,
  DEFAULT_TIMEOUT: 100 * 1000,
}